<template>
  <BaseTitle :schedule="schedule" :metadata-items="visibleMetadataList">
    <template v-if="schedule.separateAccountManagerFee">
      {{ schedule.programName || schedule.name }}
    </template>
  </BaseTitle>
</template>
<script>
import BaseTitle from './BaseTitle';
import HistoricMaxFeeMetadataMixin from '../../mixins/metadata/historic-max-fee-mixin';

export default {
  name: 'max-fee-title',
  components: {
    BaseTitle,
  },
  mixins: [HistoricMaxFeeMetadataMixin],
  props: {
    schedule: Object,
    showMetadata: Boolean,
  },
  inject: ['translate', 'formatNumber'],
  computed: {
    metadataList() {
      const metadataList = [
        {
          label: this.feeScheduleDescription,
        },
        {
          label: this.maxDiscountDescription,
        },
      ];
      if (this.schedule.separateAccountManagerFee) {
        metadataList.push({
          label: this.SMAFeeExcludedDescription,
        });
      }
      return metadataList;
    },
    visibleMetadataList() {
      if (this.showMetadata) {
        return this.metadataList;
      }
      return [];
    },
    feeScheduleDescription() {
      return this.translate('historicMaxFee');
    },
  },
};
</script>
